// @flow

import React, { PureComponent } from 'react';
import _ from 'lodash';
import BackspaceProvider from './backspaceProvider';
import InputGroup from './inputGroup';

export function formatWithCommas(
  val: string | number,
  isDelEvent?: boolean,
  allowNegative?: boolean,
) {
  const value = val.toString();
  const [integerPortion, decimalPortion = ''] = value.split('.');
  const hasDecimal = value.match(/\./);
  if (isDelEvent && hasDecimal) {
    return val;
  }
  const isNegative = value.match(/-/);
  const cleanedInt = integerPortion.replace(/[^0-9]/g, '');
  const interval = 3;
  // cuts out any extraneous numbers
  const vals = cleanedInt.substr(0, 9);
  const maxGroups = Math.ceil(vals.length / interval);
  const ints = [];
  _.times(maxGroups, (i) => {
    const start = (i + 1) * interval;
    const stop = start > vals.length ? vals.length % interval : interval;
    ints.unshift(vals.substr(-1 * start, stop));
  });
  const delimiter = ',';
  // puts delimiter between groups
  let delimitedVal = ints.filter(v => v).join(delimiter);
  // const valsLen = vals.length;
  // appends a delimiter to the end when it's a multiple of the interval
  if (isNegative && allowNegative) {
    delimitedVal = `-${delimitedVal}`;
  }
  if (hasDecimal) {
    const roundedDecimal = decimalPortion.substr(0, 2);
    delimitedVal += `.${roundedDecimal}${roundedDecimal.length === 1 ? '0' : ''}`;
  }
  return delimitedVal;
}

type Props = {
  value: string | number,
  changeHandler: Function,
  allowNegative: boolean,
};

class InputCurrency extends PureComponent<Props> {
  static defaultProps = {
    changeHandler: () => {},
    allowNegative: false,
  };

  render() {
    const { changeHandler, allowNegative, ..._props } = this.props;
    return (
      <BackspaceProvider>
        <InputGroup
          {..._props}
          // Since iOS keyboards do not have both '.' and '-' on their keyboard
          // for decimal, tel, or numeric, we default to regular text when we
          // allowNegatives
          inputMode={allowNegative ? 'text' : 'decimal'}
          symbol="$"
          type="text"
          onChange={(e, backspace) => {
            const dashDate = formatWithCommas(e.target.value, backspace, allowNegative);
            changeHandler(dashDate);
          }} />
      </BackspaceProvider>
    );
  }
}

export default InputCurrency;
